import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
} from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

@Component({
  templateUrl: './direct-booking.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DirectBookingPage {
  readonly windowService = inject(WindowService);
}
